import i18n from "@/i18n";

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly correlationId: string | null,
    public readonly body: unknown,
    message?: string,
  ) {
    super(message ?? `API error ${status}`);
    this.name = "ApiError";
  }
}

export function extractCorrelationId(headers: Headers): string | null {
  return headers.get("x-correlation-id") ?? headers.get("x-request-id");
}

/** Best-effort human-readable message from any thrown mutation/query error. */
export function apiErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    // A raw backend error code (e.g. "forbidden") is never useful shown
    // verbatim to a user, and which permission they were missing isn't
    // actionable information anyway — always show a plain explanation
    // instead, regardless of what the response body contains.
    if (error.status === 403) {
      return i18n.t("common:errors.forbidden");
    }
    const body = error.body;
    if (body && typeof body === "object") {
      const b = body as { message?: unknown; error?: unknown };
      if (typeof b.message === "string" && b.message) return b.message;
      if (typeof b.error === "string" && b.error) return b.error;
    }
    return i18n.t("common:errors.request_failed", { status: error.status });
  }
  if (error instanceof Error && error.message) return error.message;
  return i18n.t("common:errors.unexpected");
}
